<template>
  <div class="platform">
    <mobile-menu v-show="menu" :closeMenu="closeMenu" />
      <header class="platform__header">
        <div class="platform__header__content">
          <div class="navigation__logo">
            <img src="./assets/railroad-08a-300x101.png" alt="">
          </div>

          <ul class="navigation">
            <router-link exact-active-class="app-button" tag="li" to="/">
              BUY TICKET <i class="fas fa-ticket-alt"></i>
            </router-link>
            <router-link class="link" exact-active-class="app-button" tag="li" to="checkin">
              Manage Booking <i class="fas fa-walking"></i>
            </router-link>
            <router-link v-show="isAuth" class="link"  exact-active-class="app-button" tag="li" to="profile">
              PROFILE
              <i class="fas fa-user-circle"></i>
            </router-link>
            <router-link @click.native="onLogout"  v-if="isAuth" class="link"  exact-active-class="app-button" tag="li" to="auth">
              LOGOUT
              <i class="fas fa-user-circle"></i>
            </router-link>
            <router-link v-else class="link"  exact-active-class="app-button" tag="li" to="auth">
              LOGIN
              <i class="fas fa-user-circle"></i>
            </router-link>
          </ul>
          <div @click="menu = true" class="navigation-icon brand-text-color">
            <i class="fas fa-bars"></i>
          </div>
        </div>
      </header>

      <main class="platform__main bg-hero">
        <div class="platform__main__content">
          <slot name="content">
          </slot>
        </div>
      </main>

      <footer class="platform__footer">

        <div>
          <span class="copyright">© Copyright - RailRoad Transport Company </span>
        </div>

        <div style="margin-left: 10px;"><strong>Call us on 09031100013 </strong></div>
        <ul class="noLightbox social_bookmarks icon_count_3">
          <li class="social_bookmarks_twitter av-social-link-twitter social_icon_1">
            <a target="_blank" href="https://twitter.com/@railroadng/">Twitter</a>
          </li><li class="social_bookmarks_facebook av-social-link-facebook social_icon_2">
            <a target="_blank" href="https://web.facebook.com/@RailRoadNg?_rdc=1&amp;_rdr">Facebook
            </a>
          </li>
          <li class="social_bookmarks_instagram av-social-link-instagram social_icon_3">
            <a target="_blank" href="https://instagram.com/railroad.ng" title="Instagram">
              <span class="avia_hidden_link_text">Instagram</span>
            </a>
          </li>
        </ul>
      </footer>
  </div>

</template>

<script>
import { getUserInfo, logout } from '@/services/auth'
import MobileMenu from '@/components/MobileMenu'

export default {
  name: 'Platform',
  components: {
    MobileMenu
  },
  data () {
    return {
      isAuth: false,
      username: 'Annoymous',
      menu: false
    }
  },
  created () {
    getUserInfo(false)
      .then(res => {
        this.isAuth = true
      })
      .catch(() => {
        // just keep silence
      })
  },
  methods: {
    onLogout () {
      logout()
      this.isAuth = false
    },
    closeMenu () {
      this.menu = false
    }
  }
}
</script>

<style src="./platform.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Platform.vue